import React from "react";
import {
  Sparkles,
  LayoutGrid,
  Brain,
  Mail,
  Handshake,
  Clapperboard,
  Target,
  TrendingUp,
  Youtube,
  MessageCircle,
  Rocket,
  ShoppingBag,
} from "lucide-react";

/**
 * Mapowanie kolorów modułów
 */
export const getModuleColors = (moduleId: string) => {
  switch (moduleId) {
    case "offer-builder":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "vsl-creator":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "ad-creator":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "marketing-analyst":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "reel-creator":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "idea-bank":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "youtube-mode":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "clone-yourself":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "email-creator":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "campaign-creator":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    case "allegro-ads":
      return {
        color: "text-[#ef3e29]",
        hoverColor: "text-white",
        shadowColor: "shadow-[#ef3e29]/50",
        borderColor: "border-[#ef3e29]",
        bgColor: "bg-[#ef3e29]",
      };
    default:
      return {
        color: "text-white/60",
        hoverColor: "text-white",
        shadowColor: "shadow-white/20",
        borderColor: "border-white/[0.12]",
        bgColor: "bg-white/10",
      };
  }
};

/**
 * Centralna funkcja do zarządzania ikonami modułów
 * Używana we wszystkich komponentach dla spójności interfejsu
 * Używa wyłącznie ikon z biblioteki Lucide dla spójności
 */
export const getModuleIcon = (
  moduleId: string,
  className: string = "w-5 h-5",
  variant: "default" | "conversation" | "colored" | "hover" = "default"
) => {
  // Dla konwersacji w sidebar - kolorowe tła z ikonami Lucide
  if (variant === "conversation") {
    switch (moduleId) {
      case "offer-builder":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Handshake className="w-5 h-5 text-white" />
          </div>
        );
      case "vsl-creator":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Clapperboard className="w-5 h-5 text-white" />
          </div>
        );
      case "ad-creator":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Target className="w-5 h-5 text-white" />
          </div>
        );
      case "marketing-analyst":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-white" />
          </div>
        );
      case "reel-creator":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
        );
      case "idea-bank":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <LayoutGrid className="w-5 h-5 text-white" />
          </div>
        );
      case "youtube-mode":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Youtube className="w-5 h-5 text-white" />
          </div>
        );
      case "clone-yourself":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Brain className="w-5 h-5 text-white" />
          </div>
        );
      case "email-creator":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Mail className="w-5 h-5 text-white" />
          </div>
        );
      case "campaign-creator":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <Rocket className="w-5 h-5 text-white" />
          </div>
        );
      case "allegro-ads":
        return (
          <div className="w-8 h-8 bg-[#ef3e29] rounded-lg flex items-center justify-center">
            <ShoppingBag className="w-5 h-5 text-white" />
          </div>
        );
      default:
        return (
          <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center">
            <MessageCircle className="w-5 h-5 text-white/70" />
          </div>
        );
    }
  }

  // Kolorowy wariant - białe ikony (dla module-tabs)
  if (variant === "colored") {
    switch (moduleId) {
      case "offer-builder":
        return <Handshake className={`${className} text-white`} />;
      case "vsl-creator":
        return <Clapperboard className={`${className} text-white`} />;
      case "ad-creator":
        return <Target className={`${className} text-white`} />;
      case "marketing-analyst":
        return <TrendingUp className={`${className} text-white`} />;
      case "reel-creator":
        return <Sparkles className={`${className} text-white`} />;
      case "idea-bank":
        return <LayoutGrid className={`${className} text-white`} />;
      case "youtube-mode":
        return <Youtube className={`${className} text-white`} />;
      case "clone-yourself":
        return <Brain className={`${className} text-white`} />;
      case "email-creator":
        return <Mail className={`${className} text-white`} />;
      case "campaign-creator":
        return <Rocket className={`${className} text-white`} />;
      case "allegro-ads":
        return <ShoppingBag className={`${className} text-white`} />;
      default:
        return <MessageCircle className={`${className} text-white`} />;
    }
  }

  // Hover wariant - białe ikony dla hover state
  if (variant === "hover") {
    switch (moduleId) {
      case "offer-builder":
        return <Handshake className={`${className} text-white`} />;
      case "vsl-creator":
        return <Clapperboard className={`${className} text-white`} />;
      case "ad-creator":
        return <Target className={`${className} text-white`} />;
      case "marketing-analyst":
        return <TrendingUp className={`${className} text-white`} />;
      case "reel-creator":
        return <Sparkles className={`${className} text-white`} />;
      case "idea-bank":
        return <LayoutGrid className={`${className} text-white`} />;
      case "youtube-mode":
        return <Youtube className={`${className} text-white`} />;
      case "clone-yourself":
        return <Brain className={`${className} text-white`} />;
      case "email-creator":
        return <Mail className={`${className} text-white`} />;
      case "campaign-creator":
        return <Rocket className={`${className} text-white`} />;
      case "allegro-ads":
        return <ShoppingBag className={`${className} text-white`} />;
      default:
        return <MessageCircle className={`${className} text-white`} />;
    }
  }

  // Domyślny wariant - tylko ikony Lucide dla spójności
  switch (moduleId) {
    case "offer-builder":
      return <Handshake className={className} />;
    case "vsl-creator":
      return <Clapperboard className={className} />;
    case "ad-creator":
      return <Target className={className} />;
    case "marketing-analyst":
      return <TrendingUp className={className} />;
    case "youtube-mode":
      return <Youtube className={className} />;
    case "reel-creator":
      return <Sparkles className={className} />;
    case "idea-bank":
      return <LayoutGrid className={className} />;
    case "clone-yourself":
      return <Brain className={className} />;
    case "email-creator":
      return <Mail className={className} />;
    case "campaign-creator":
      return <Rocket className={className} />;
    case "allegro-ads":
      return <ShoppingBag className={className} />;
    default:
      return <MessageCircle className={className} />;
  }
};
